var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M12 20a7.952 7.952 0 0 1-4.897-1.688l11.209-11.21A7.955 7.955 0 0 1 20.001 12c0 4.411-3.59 8-8.001 8zm-8-8c0-4.411 3.589-8 8-8 1.846 0 3.543.635 4.897 1.688L5.688 16.898A7.952 7.952 0 0 1 3.999 12zm8-10C6.478 2 2 6.477 2 12c0 5.522 4.478 10.001 10 10.001S22 17.522 22 12c0-5.523-4.478-10-10-10z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.eae9a73f9ddbd76c181832cc85370731.svg";
export { ForwardRef as ReactComponent };